import React from 'react';
import { Group } from '@visx/group';
import { scaleBand, scaleLinear } from '@visx/scale';
import { HeatmapRect } from '@visx/heatmap';
import { AxisBottom, AxisLeft } from '@visx/axis';
import { LinearGradient } from '@visx/gradient'

const hot1 = '#005bea';
const hot2 = '#f33d15';

/*
genBins generates a height x width array of Bin's where a Bin has a index and a count, the count stores the value

TODO:
1) Make a phosphoData to bin structure converter function (Done)
2) Look into Left/Right Axis Labels (Done)
3) Separate Heatmaps (Sort)
4) Curse Visx for not documenting shit. (Done)
5) Look into how to adjust height for getting good heatmaps
6) Box borders on hover

*/

function max(data, value) {
    return Math.max(...data.map(value));
}

function min(data, value) {
    return Math.min(...data.map(value));
}

export function phosphoBinConverter(peptideData) {
    const domain_Y = [];
	var heatBin = [
  	{'bin': "Amygdala(LH)", 'bins': []},
    {'bin': "Brain Stem(LH)", 'bins': []},
    {'bin': "Cingullum(LH)", 'bins': []},
    {'bin': "Caudate Nucleus(LH)", 'bins': []},
    {'bin': "Cerebellar Vermis(LH)", 'bins': []},
    {'bin': "Dentate Gyrus(LH)", 'bins': []},
    {'bin': "Frontal Cortex(LH)", 'bins': []},
    {'bin': "Hippocampus(LH)", 'bins': []},
    {'bin': "Motor Cortex(LH)", 'bins': []},
    {'bin': "Substantia Nigra(LH)", 'bins': []},
    {'bin': "Spinal Cord(LH)", 'bins': []},
    {'bin': "Thalamus(LH)", 'bins': []},
	{'bin': "Amygdala(RH)", 'bins': []},
    {'bin': "Brain Stem(RH)", 'bins': []},
    {'bin': "Cingullum(RH)", 'bins': []},
    {'bin': "Caudate Nucleus(RH)", 'bins': []},
    {'bin': "Cerebellar Vermis(RH)", 'bins': []},
    {'bin': "Dentate Gyrus(RH)", 'bins': []},
    {'bin': "Frontal Cortex(RH)", 'bins': []},
    {'bin': "Hippocampus(RH)", 'bins': []},
    {'bin': "Motor Cortex(RH)", 'bins': []},
    {'bin': "Substantia Nigra(RH)", 'bins': []},
    {'bin': "Spinal Cord(RH)", 'bins': []},
    {'bin': "Thalamus(RH)", 'bins': []},
  ]

    for (var peptideIndex in peptideData) {
        var peptide = peptideData[peptideIndex];
        var pepSequence = peptide.peptideSequence;
        var phosphoAA = peptide.phosphoAminoAcid;
        var phosphoPos = peptide.phosphoPos;

        domain_Y.push(`${phosphoAA}${phosphoPos}`)
        for (const [key, value] of Object.entries(peptide)) {
            var smallBin = {bin: pepSequence, count: value};
            switch (key) {
                case "AMY_L_Phos": heatBin[0].bins.push(smallBin);
                break;
                case "BS_L_Phos": heatBin[1].bins.push(smallBin);
                break;
                case "CING_L_Phos": heatBin[2].bins.push(smallBin);
                break;
                case "CN_L_Phos": heatBin[3].bins.push(smallBin);
                break;
                case "CV_L_Phos": heatBin[4].bins.push(smallBin);
                break;
                case "DG_L_Phos": heatBin[5].bins.push(smallBin);
                break;
                case "FC_L_Phos": heatBin[6].bins.push(smallBin);
                break;
                case "HIP_L_Phos": heatBin[7].bins.push(smallBin);
                break;
                case "MC_L_Phos": heatBin[8].bins.push(smallBin);
                break;
                case "SN_L_Phos": heatBin[9].bins.push(smallBin);
                break;
                case "SC_L_Phos": heatBin[10].bins.push(smallBin);
                break;
                case "THAL_L_Phos": heatBin[11].bins.push(smallBin);
                break;
                case "AMY_R_Phos": heatBin[12].bins.push(smallBin);
                break;
                case "BS_R_Phos": heatBin[13].bins.push(smallBin);
                break;
                case "CING_R_Phos": heatBin[14].bins.push(smallBin);
                break;
                case "CN_R_Phos": heatBin[15].bins.push(smallBin);
                break;
                case "CV_R_Phos": heatBin[16].bins.push(smallBin);
                break;
                case "DG_R_Phos": heatBin[17].bins.push(smallBin);
                break;
                case "FC_R_Phos": heatBin[18].bins.push(smallBin);
                break;
                case "HIP_R_Phos": heatBin[19].bins.push(smallBin);
                break;
                case "MC_R_Phos": heatBin[20].bins.push(smallBin);
                break;
                case "SN_R_Phos": heatBin[21].bins.push(smallBin);
                break;
                case "SC_R_Phos": heatBin[22].bins.push(smallBin);
                break;
                case "THAL_R_Phos": heatBin[23].bins.push(smallBin);
                break;
            };
        };
    }
    return {'heatbin': heatBin,'domain_Y': domain_Y}
}

const defaultMargin = { top: 10, left: 100, right: 100, bottom: 100 };

export default function PhosphoHeatMap({ rawPeptideData, width, height, events = true, margin = defaultMargin, separation = 0}) {
    // data
    const processedData = phosphoBinConverter(rawPeptideData);
    const heatmapData = processedData.heatbin;
    const domain_Y = processedData.domain_Y;
    
    // accessors
    const bins = (d) => d.bins; // For a Bins object
    const count = (d) => d.count; // For a Bin object

    const colorMax = max(heatmapData, (d) => max(bins(d), count));
    const bucketSizeMax = max(heatmapData, (d) => bins(d).length);
    
    
    // bounds
    const size =
        width > margin.left + margin.right
            ? width - margin.left - margin.right - separation
            : width;
    const xMax = size;
    const yMax = height - margin.bottom - margin.top;

    
    const binWidth = xMax / heatmapData.length;
    const binHeight = yMax / bucketSizeMax;

    const domain_R = ['AMY(LH)','BS(LH)','CING(LH)','CN(LH)','CV(LH)','DG(LH)','FC(LH)','HIP(LH)','MC(LH)','SC(LH)','SN(LH)','THAL(LH)','AMY(RH)','BS(RH)','CING(RH)','CN(RH)','CV(RH)','DG(RH)','FC(RH)','HIP(RH)','MC(RH)','SC(RH)','SN(RH)','THAL(RH)'];

    const xScale = scaleBand({
        round: true,
        domain: domain_R,
        padding: 0.2,
    });

    const yScale = scaleBand({
        domain: domain_Y,
        round: true,
        padding: 0.1,
    });

    const colorScale = scaleLinear({
        range: [hot1, hot2],
        domain: [0, colorMax],
    });

    xScale.range([0, xMax]);
    yScale.range([yMax, 0]);

    return width < 10 ? null : (
        <svg width={width} height={height}>
            <LinearGradient to="#e6e9f0" from="#eef1f5" id='snowagain'/>
            <rect x={0} y={0} width={width} height={height} rx={14} fill="white" />
            <Group top={margin.top} left={100}>
                <HeatmapRect
                    data={heatmapData}
                    xScale={(d) => xScale(domain_R[d]) ?? 0}
                    yScale={(d) => yScale(domain_Y[d]) ?? 0}
                    colorScale={colorScale}
                    binWidth={binWidth}
                    binHeight={binWidth}
                    gap={6}
                >
                    {(heatmap) =>
                        heatmap.map((heatmapBins) =>
                            heatmapBins.map((bin) => (
                                <rect
                                    key={`heatmap-rect-${bin.row}-${bin.column}`}
                                    className="visx-heatmap-rect"
                                    width={bin.width}
                                    height={bin.height}
                                    x={bin.x}
                                    y={bin.y}
                                    fill={bin.color}
                                    fillOpacity={1}
                                    onClick={() => {
                                        if (!events) return;
                                        const { row, column } = bin;
                                        alert(JSON.stringify({ row, column, bin: bin.bin }));
                                    }}
                                    style={{ cursor: "pointer" }}
                                />
                            )),
                        )
                    }
                </HeatmapRect>
                <AxisBottom
                    numTicks={heatmapData.length - 1}
                    hideTicks
                    hideAxisLine
                    label={"Regions (with Hemisphere)"}
                    labelProps={{
                        fill: '#000000',
                        fontSize: 25,
                        y: 90,
                        textAnchor: 'top',
                    }}
                    top={yMax}
                    scale={xScale}
                    tickLabelProps={(value, index) => ({
                        fill: '#000000',
                        fontSize: 13,
                        textAnchor: 'top',
                        y: 10,
                        angle: 90,
                    })}
                />
                <AxisLeft
                    numTicks={domain_Y.length}
                    hideTicks
                    hideAxisLine
                    label={"Phospho Sites"}
                    labelProps={{
                        fill: '#000000',
                        fontSize: 25,
                        textAnchor: 'top',
                    }}
                    top={0}
                    scale={yScale}
                    tickLabelProps={(value, index) => ({
                        fill: '#000000',
                        fontSize: 13,
                        textAnchor: 'top',
                        x: -20,
                        transform: "translate(0,10)"
                    })}
                />
            </Group>
        </svg>
    );
};
